import { useNavigate } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';
import { PackageSearch } from 'lucide-react';
import Panel from '@/components/Panel';

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--app-bg)] p-4">
      <Panel className="max-w-md p-8 text-center">
        <PackageSearch size={44} className="mx-auto mb-3 text-primary-400" />
        <h1 className="text-xl font-bold text-[var(--app-text)]">Nothing on this shelf</h1>
        <p className="mt-1 text-sm text-[var(--app-muted)]">
          The page you asked for doesn't exist.
        </p>
        <Button className="mt-5" onClick={() => nav('/')}>
          Back to the dashboard
        </Button>
      </Panel>
    </div>
  );
}
